export enum FiTaskToCompleteTabsEnum {
    AssignedToMe,
    Private,
    AssignedByMe,
}
